import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <h1>Welcome to Kade's Kloset</h1>
      <div className='hero-btns'>
        <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
          to = "/shop"
          onClick = {() => window.scrollTo(0, 0)}
        >
          SHOP NOW
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;
